"use client";

import { type AddToCartSource } from "@/app/components/shared/recommended-products/add-to-cart-event";
import { useAddToCart } from "@/app/hooks/useAddToCart";
import { type AddedProductSnapshot } from "@/app/store/cart/add-to-cart-slider-store";
import { type AddToCartActionStatus } from "@/app/actions/cart";

export interface UseAddToCartSliderArgs {
	sku: string;
	quantity: number;
	product: AddedProductSnapshot;
	source?: AddToCartSource;
}

export interface UseAddToCartSliderReturn {
	onClick: () => void;
	state: {
		loading: boolean;
		error: string | null;
		errorStatus: AddToCartActionStatus | null;
	};
}

export function useAddToCartSlider(
	args: UseAddToCartSliderArgs
): UseAddToCartSliderReturn {
	const { handleClick, loading, error, errorStatus } = useAddToCart(
		{
			productCode: args.sku,
			quantity: String(args.quantity),
			purchaseType: "oneTime"
		},
		{ product: args.product, source: args.source ?? "pdp" }
	);

	return {
		onClick: handleClick,
		state: { loading, error, errorStatus }
	};
}
